import React from "react";

import { SearchScope } from "fond/topBar/useSearchScope";
import { PageContent } from "fond/widgets";

import { Navigation } from "../Navigation";

import SearchResultContainer from "./SearchResultContainer";

interface SearchResultsProps {
  searchQuery: string;
  scope: SearchScope;
}

const SearchResults: React.FC<SearchResultsProps> = ({ searchQuery, scope }) => (
  <PageContent
    title="Search"
    mainContent={<SearchResultContainer searchQuery={searchQuery} scope={scope} />}
    navigation={<Navigation />}
    testId="search-results"
  />
);

export default SearchResults;
